<script lang="ts">
	import { defineComponent } from "vue";
	import BannerCampus from "../components/landing/BannerCampusSlider.vue";
    import FormarBloqueLanding from "../components/landing/FormarBloqueLanding.vue";
    import Oferta from "../components/landing/Oferta.vue";
    import Ubicacion from "../components/landing/Ubicacion.vue";
    import Instalaciones from "../components/landing/Instalaciones.vue";
    import Tour360 from "../components/landing/Tour360.vue";
	// import ModelosEducativos from "../components/landing/ModelosEducativos.vue";
	// import OfertaEducativa from "../components/landing/OfertaEducativa.vue";
	// import HumanitasMuchoMas from "@/components/HumanitasMuchoMas.vue";


	export default defineComponent({
		name: "CampusRivieraMaya",
		components: {
			BannerCampus,
            FormarBloqueLanding,
            Oferta,
            Ubicacion,
            Instalaciones,
            Tour360
		},
		props: {
			campus: {
				type: String,
				required: true,
			},
			banner: {
				type: String,
				required: true,
			},
        },
        data() {
            return {
                currentImage: 0,
                currentImage2: 0,
                images: [
                    '/pagesImages/riviera-maya-instalaciones-1.webp',
                    '/pagesImages/riviera-maya-instalaciones-2.webp',
                    '/pagesImages/riviera-maya-instalaciones-3.webp',
                    '/pagesImages/riviera-maya-instalaciones-4.webp',
                    '/pagesImages/riviera-maya-instalaciones-5.webp',
                ],
                images2: [
                    '/pagesImages/riviera-maya-instalaciones-6.webp',
                    '/pagesImages/riviera-maya-instalaciones-7.webp',
                    '/pagesImages/riviera-maya-instalaciones-8.webp',
                    '/pagesImages/riviera-maya-instalaciones-9.webp',
                    '/pagesImages/riviera-maya-instalaciones-10.webp',
                ],
                imagesArray: [
                    "/pagesImages/encabezado-landing-Riviera-Maya.webp",
                ],
                altArray: [
                    "Fotos de campus Magno Riviera Maya",
                    "Fotos de campus Magno Riviera Maya",
                ],
                tour: [
                    { src:"/pagesImages/tour-Valle-2.webp", title:"Tour virtual en Campus Magno Riviera Maya"},
                    { src:"/pagesImages/tour-Valle-3.webp", title:"Tour virtual en Campus Magno Riviera Maya"},
                    { src:"/pagesImages/tour-Valle-5.webp", title:"Tour virtual en Campus Magno Riviera Maya"},
                    { src:"/pagesImages/tour-Valle-7.webp", title:"Tour virtual en Campus Magno Riviera Maya"},
                    { src:"/pagesImages/tour-Valle-8.webp", title:"Tour virtual en Campus Magno Riviera Maya"},
                    { src:"/pagesImages/tour-Valle-9.webp", title:"Tour virtual en Campus Magno Riviera Maya"},
                    { src:"/pagesImages/tour-Valle-10.webp", title:"Tour virtual en Campus Magno Riviera Maya"},
                ],
                campusName: "RIVIERA MAYA",
                campusType: "CAMPUS MAGNO",
                localidad: "QUINTANA ROO",
                frase: "No es que tengamos poco tiempo, sino que perdemos mucho",
                autor: "Séneca",
            }
        },
        methods: {
            nextImage() {
                this.currentImage = (this.currentImage + 1) % this.images.length
            },
            nextImage2() {
                this.currentImage2 = (this.currentImage2 + 1) % this.images2.length
            }
        }
	});
</script>

<template>
	<!-- <BannerCampus :banner="banner"/> -->
    <BannerCampus :campusType="campusType" :campus="campusName" :localidad="localidad" :slider="imagesArray" :alt="altArray" :frase="frase" :autor="autor" :banner="banner"/>
    <FormarBloqueLanding :frase="'Campus Magno Riviera Maya'" :testo1="'Consolida la presencia de la institución en el sureste mexicano, ofreciendo una propuesta académica competitiva que combina calidad educativa, innovación y altos estándares formativos.'" :testo2="'Se proyecta como una de las opciones más atractivas de la región, bajo la excelencia académica y espacios diseñados para maximizar la experiencia del estudiante.'" :testo3="'Ubicado en un entorno natural privilegiado, el campus potencia el pensamiento crítico, la capacidad de análisis y la aplicación práctica del conocimiento.'" :img="'/pagesImages/riviera-maya-una-mirada.webp'" :alt="'Panorámica de Campus Magno Riviera Maya'" class="mb-16" />
    <div class="flex items-center justify-center w-full mb-16 relative">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8">
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-8 leading-none w-full">Instalaciones</h2>
            <p class="text-center mb-8">Es un entorno que combina infraestructura moderna y naturaleza, cuenta con espacios abiertos,<br class="lg:block hidden"> extensas áreas verdes y servicios educativos de primer nivel.</p>
            <div class="flex flex-col justify-between">
                <div class="lg:flex items-center justify-center mb-16">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12 space-y-8">
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Áreas especializadas</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Sus espacios están diseñados y adaptados para la impartición de diversas disciplinas como Arquitectura, Derecho y Psicología, con inmobiliario como cámara Gesell y sala de juicios orales para la recreación de entornos profesionales y la consolidación de competencias.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Aulas interactivas</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Las aulas se encuentran equipadas con tecnología audiovisual de alta calidad, incluyendo proyectores y sistemas de audio integrados.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Biblioteca y recursos digitales</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Con acceso a libros físicos, bases de datos digitales y computadoras. Este espacio fomenta el estudio en un entorno cómodo y bien equipado.</p>
                        </div>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px] relative">
                        <img
                        :src="images[currentImage]"
                        alt="Instalaciones de Campus Magno Riviera Maya"
                        class="w-full lg:max-w-[520px]"
                        />
                        <button
                        @click="nextImage"
                        class="absolute top-1/2 right-2 transform -translate-y-1/2 bg-white/50 text-black focus:outline-none px-4 p-2 rounded-full hover:bg-white/30 transition"
                        >
                        &gt;
                        </button>
                    </div>
                </div>
            </div>
            <div class="flex flex-col justify-between">
                <div class="flex lg:flex-row flex-col items-center justify-center">
                    <div class="flex lg:order-1 order-2 items-center justify-center w-full lg:max-w-[520px] relative">
                        <img
                        :src="images2[currentImage2]"
                        alt="Jardines de Campus Magno Riviera Maya"
                        class="w-full lg:max-w-[520px]"
                        />
                        <button
                        @click="nextImage2"
                        class="absolute top-1/2 right-2 transform -translate-y-1/2 bg-white/50 text-black focus:outline-none px-4 p-2 rounded-full hover:bg-white/30 transition"
                        >
                        &gt;
                        </button>
                    </div>
                    <div class="lg:w-[50%] order-1 lg:order-2 text-justify mb-8 lg:mb-0 lg:ml-12 space-y-8">
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Auditorio</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">En este recinto se realizan eventos culturales, conferencias, encuentros multidisciplinarios, foros, debates y presentaciones.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Áreas verdes y deportivas</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Canchas y zonas recreativas que promueven un estilo de vida saludable, integrando deporte y bienestar en la rutina estudiantil.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Cafetería</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Despierta es un concepto de cafeterías que fusiona una alimentación saludable con el sabor casero de una comida nutritiva.</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="grid lg:grid-cols-2 grid-cols-1 gap-10">
                
            </div> -->
        </div>
    </div>
    <h2 class="text-hgold text-center font-serif md:text-[42px] text-[32px] lg:px-0 px-8 lg:mb-4 leading-none w-full">Oferta académica en Campus Magno Riviera Maya</h2>
    <Oferta :virtual=false :visibleOffers="{
        Licenciaturas: ['Administración', 'Contabilidad', 'Psicología' , 'Derecho', 'Arquitectura', 'Diseño Gráfico'],
        Maestrías: ['Alta Dirección', 'Derecho Corporativo', 'Psicoterapia con un<br> enfoque Psicoanalítico', ]
    }" class="flex items-center justify-center" />
    <!-- <Oferta :virtual=false :visibleOffers="{
        Licenciaturas: ['Administración', 'Contabilidad', 'Psicología' , 'Derecho', 'Arquitectura', 'Diseño Gráfico'],
        Maestrías: ['Alta Dirección', 'Derecho Corporativo', 'Derecho Fiscal', 'Derecho Penal', 'Psicoterapia con un<br> enfoque Psicoanalítico', 'Mercadotecnia Digital', 'Justicia Penal', 'Contabilidad', 'Educación', ],
        Doctorados: ['Alta Dirección', 'Derecho', 'Educación']
    }" class="flex items-center justify-center" /> -->
    <!-- <section class="flex w-full items-center justify-center my-10">
        <div class="lg:flex w-full max-w-[1200px] justify-center items-center mb-6">
            <div class="flex flex-col md:pr-14 pb-7 md:pb-0 w-full md:w-1/2 items-center md:items-end lg:px-16 px-8">
                <li class="list-none flex flex-col items-center md:items-start">
                    <h3 class="text-center md:text-left line-height-36 text-3xl md:text-4xl text-hgold mb-4 font-serif">Diplomados</h3>
                    <ul class="text-left pl-6 list-disc space-y-1 mb-4">
                        <li class="">
                            <a href="https://humanitas.edu.mx/educacion-continua">Tanatología</a>
                        </li>
                        <li class="">
                            <a href="https://humanitas.edu.mx/educacion-continua">Criminología</a>
                        </li>
                    </ul>
                </li>
            </div>
            <div class="flex w-full md:w-1/2 justify-center md:justify-start lg:px-0 px-8">
                <img src="/pagesImages/square-docs.webp" width="494" height="494" loading="lazy" class="w-auto h-auto" alt="Explora los Diplomados">
            </div>
        </div>
    </section> -->
    <div class="flex items-center justify-center w-full mb-16 mt-6 relative">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8">
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-16 leading-none w-full">Nuestros modelos educativos</h2>
            <section class="flex items-center justify-center mb-16 w-full">
                <div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
                    <div class="flex flex-col justify-between">
                        <div class="lg:flex items-center justify-center">
                            <div class="flex items-center justify-center w-full lg:max-w-[520px]">
                                <img src="/pagesImages/mujer-modelo-ejecutivo-universidad-humanitas.webp" alt="Modelo ejecutivo en Campus Magno Riviera Maya" class="w-full lg:max-w-[520px]"/>
                            </div>
                            <div class="lg:w-[50%] text-justify mt-8 lg:mt-0 lg:ml-12">
                                <h3>
                                    <!-- <span class="block text-[#73793B] leading-none text-left text-[28px]" style=""></span>
                                    <span class="sr-only whitespace-nowrap">&nbsp;</span> -->
                                    <span class="block text-hgold text-left font-serif mb-3 text-3xl md:text-4xl">Modelo ejecutivo</span>
                                </h3>
                                <p class=" lg:hyphens-none hyphens-auto">
                                    Está diseñado para brindar flexibilidad sin comprometer la calidad académica. Los programas se estructuran en bloques trimestrales, cada uno fusionando tres materias, impartidas por especialistas. Requiere autodisciplina, gestión eficiente del tiempo y compromiso con el éxito académico.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="flex items-center justify-center w-full">
                <div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
                    <div class="flex flex-col justify-between">
                        <div class="lg:flex items-center justify-center">
                            <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                                <h3>
                                    <span class="block text-hgold text-left font-serif mb-3 text-3xl md:text-4xl">Modelo escolarizado</span>
                                </h3>
                                <p class="lg:hyphens-none hyphens-auto">
                                    Ofrece una formación académica de calidad con un enfoque práctico y humano. Cada licenciatura está diseñada con objetividad e integrada con talleres y seminarios, que potencian la preparación para enfrentar los desafíos del mundo actual con conocimiento, habilidades y experiencia.
                                </p>
                            </div>
                            <div class="flex items-center justify-center w-full lg:max-w-[520px]">
                                <img src="/pagesImages/alumnos-sistema-escolarizado-universidad-humanitas.webp" alt="Modelo escolarizado en Campus Magno Riviera Maya" class="w-full lg:max-w-[520px]"/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
    <!-- <div class="flex items-center justify-center w-full mb-16 relative">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8"> -->
            <!-- <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-8 leading-none w-full">Tour virtual</h2> -->
            <!-- <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-10 leading-none w-full">Galería</h2>
            <p class="mb-10">Conoce el Campus Magno Riviera Maya en nuestra galeria.</p>
            <Instalaciones :items="tour" class="" /> -->
            <!-- <Tour360 :src="'https://tourmkr.com/F1pIoGvp7L/46969829p&102.29h&88.51t'"  class="w-full mb-12"/> -->
            <!-- <iframe width="1140" height="641" src="https://www.youtube.com/embed/qBOIBjsj3RE" title="Campus Presa Madín" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> -->
        <!-- </div>
    </div> -->
	<Ubicacion :campus="'Campus Magno Riviera Maya'" :mapa="'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d539.0735352174871!2d-87.04773171626022!3d20.681666659117003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f4e5ddf364c8b99%3A0xc24501d9acf8a1c4!2sUniversidad%20Humanitas%20Campus%20Riviera%20Maya!5e0!3m2!1ses!2smx!4v1781641027424!5m2!1ses!2smx'" :testo1="'Desde Cancún y Playa del Carmen, se debe tomar la autopista con dirección a Tulum, siguiendo la señalización correspondiente. El tiempo estimado de traslado es de aproximadamente 1 hora con 20 minutos desde Cancún y de 30 a 40 minutos desde Playa del Carmen.'" :testo2="'Desde Tulum, el acceso se realiza tomando la autopista en dirección a Playa del Carmen o Cancún, con un tiempo aproximado de 15 a 25 minutos.'" :testo3="'Referente al transporte público, desde Cancún, se recomienda dirigirse a la terminal de ADO ubicada en el centro, en la intersección de Avenida Tulum y Avenida Uxmal, punto conocido por servicios de transporte público y privado.'" :ubicacion="'Av Xelha con Calle caracoles, mz 031, lote 001, Colonia Playa del Sol C.P. 77726, Playa del Carmen, Q.R.'" :telefono="'984-980-1039'" class="lg:px-0 px-8" />
</template>

<style scoped>
</style>
